import React, { useState } from 'react';
import { CategoriesList } from '@/components/admin/categories/CategoriesList';
import { CategoryDialog } from '@/components/admin/categories/CategoryDialog';
import type { Category } from '@/types/category'; // Removido Subcategory

// TODO: Idealmente, este componente estaria dentro de um layout de admin
export default function AdminCategoriesPage() {
    const [isDialogOpen, setIsDialogOpen] = useState(false);
    // Mode agora só precisa ser 'addCategory' ou 'editCategory'
    const [dialogMode, setDialogMode] = useState<'addCategory' | 'editCategory' | null>(null);
    // currentItem será sempre do tipo Category ou null
    const [currentItem, setCurrentItem] = useState<Category | null>(null);
    // parentCategoryId não é mais necessário aqui
    // const [parentCategoryId, setParentCategoryId] = useState<string | null>(null);
    const [refreshKey, setRefreshKey] = useState(0);

    const handleAddCategory = () => {
        setDialogMode('addCategory');
        setCurrentItem(null);
        setIsDialogOpen(true);
    };

    // Removido handleAddSubcategory
    // Removido handleEditSubcategory

    const handleEditCategory = (category: Category) => {
        setDialogMode('editCategory');
        setCurrentItem(category);
        setIsDialogOpen(true);
    };

    const handleCloseDialog = () => {
        setIsDialogOpen(false);
        setTimeout(() => {
             setDialogMode(null);
             setCurrentItem(null);
        }, 300)
    };

    const handleSuccess = () => {
        handleCloseDialog();
        setRefreshKey(prevKey => prevKey + 1);
    };

    return (
        <div className="container mx-auto p-4 md:p-6">
            {/* Poderia adicionar Tabs aqui no futuro para alternar entre Categorias e Subcategorias */}
            <h1 className="text-2xl font-bold mb-4">Gerenciamento de Categorias Principais</h1>

            <CategoriesList
                onAddCategory={handleAddCategory}
                onEditCategory={handleEditCategory}
                refreshKey={refreshKey}
                // Removidas props onAddSubcategory e onEditSubcategory
            />

            {/* CategoryDialog agora só lida com add/edit de Category */}
             <CategoryDialog
                 isOpen={isDialogOpen}
                 mode={dialogMode}
                 itemToEdit={currentItem}
                 // parentCategoryId removido
                 onClose={handleCloseDialog}
                 onSuccess={handleSuccess}
            />
        </div>
    );
}
